// Shared Checkout Helpers - Movido de utils/checkoutHelpers
import { PaymentMethod } from '../../types/battery'

export const formatPaymentMethod = (method: PaymentMethod | null): string => {
  if (!method) return 'Método não selecionado'

  const methodNames: Record<PaymentMethod, string> = {
    'credit_card': 'Cartão de Crédito',
    'debit_card': 'Cartão de Débito',
    'pix': 'PIX',
    'boleto': 'Boleto Bancário'
  }

  return methodNames[method] || method
}

export const convertPaymentMethod = (method: PaymentMethod | null): string => {
  if (!method) return 'PIX'

  const methodMap: Record<string, string> = {
    'pix': 'PIX',
    'credit_card': 'CREDIT_CARD',
    'debit_card': 'DEBIT_CARD',
    'boleto': 'BOLETO'
  }

  return methodMap[method] || 'PIX'
}

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(price)
}

